import { render, staticRenderFns } from "./EachMessageReport.vue?vue&type=template&id=1b596c80&scoped=true&"
import script from "./EachMessageReport.vue?vue&type=script&lang=js&"
export * from "./EachMessageReport.vue?vue&type=script&lang=js&"
import style0 from "./EachMessageReport.vue?vue&type=style&index=0&id=1b596c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b596c80",
  null
  
)

export default component.exports